module.exports = __webpack_public_path__ + "static/media/sheath.aa862d1b.mp3";